/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {Subscription} from 'rxjs';

export class WidgetWindow extends Window {
    nlrpContext?: any;
}

@Injectable({
    providedIn: 'root'
})
export class WindowWidgetsService {
    title = 'WindowWidgetsService';

    widgets: WidgetWindow[] = [];

    private readonly unloadCallbacks: Array<() => void> = [];

    registerBeforeUnload(cb: () => void) {
        console.log('push callback');
        this.unloadCallbacks.push(cb);
    }

    open(context: any) {
        const zoomRatio = Math.round(window.devicePixelRatio * 100);

        const width = ((context.widgetWidth || context.minWidth) * zoomRatio) / 100 + 18;
        const height = ((context.widgetHeight || context.minHeight) * zoomRatio) / 100 + (context.widgetHeight ? 20 : 285);
        const screenAdjustedLeft = window.screenLeft + context.left;
        const screenAdjustedTop = window.screenTop + context.top;
        const left = (screenAdjustedLeft * zoomRatio) / 100 + 14;
        const top = !window.screenTop && !window.screenY ? (screenAdjustedTop * zoomRatio) / 100 + 60 : (screenAdjustedTop * zoomRatio) / 100 + 70;
        const widgetWindow: WidgetWindow = window.open(
            '/window-widgets',
            context.name,
            `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=${left},top=${top},width=${width},height=${height}`
        );

        // Close widget window when parent window closes
        window.addEventListener('beforeunload', () => {
            setTimeout(() => {
                widgetWindow.close();
            }, 1000);
            this.close(widgetWindow.name);
        });

        widgetWindow.nlrpContext = context;

        widgetWindow.onbeforeunload = () => {
            for (const fn of this.unloadCallbacks.splice(0)) {
                try {
                    console.log('unload callback');
                    fn();
                } catch (e) {
                    console.error('unload cb failed', e);
                }
            }
            if (!widgetWindow.nlrpContext.docking) {
                widgetWindow.nlrpContext.closeFn();
            }
        };

        widgetWindow.onload = () => {
            widgetWindow.document.title = context.title;
        };

        this.widgets.push(widgetWindow);

        widgetWindow.moveTo(left, top);
        widgetWindow.focus();

        return widgetWindow;
    }

    getMainWindow() {
        const widgetWindow = window as WidgetWindow;
        return widgetWindow.nlrpContext && widgetWindow.opener ? (widgetWindow.opener as WidgetWindow) : widgetWindow;
    }

    structuredClone<T>(value: T): T {
        return this.getMainWindow().structuredClone(value);
    }

    isOpen(name: string) {
        return this.widgets.some(w => w.name === name);
    }

    close(name: string) {
        const widgetIndex = this.widgets.findIndex(w => w.name === name);
        if (widgetIndex !== -1) {
            this.widgets
                .splice(widgetIndex)
                .filter(w => !w.closed)
                .forEach(w => w.close());
        }
    }

    closeAll() {
        this.widgets.filter(w => !w.closed).forEach(widget => widget.close());
        this.widgets.length = 0;
    }

    refreshAll() {
        this.widgets.forEach(w => w.nlrpContext.childChangeDetectorRef?.detectChanges());
    }
}
